import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  User, 
  Package, 
  Globe, 
  Shield, 
  Compass
} from 'react-feather';

const Sidebar = () => {
  const location = useLocation();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const getButtonClass = (path) => {
    return `w-16 h-16 rounded-lg flex items-center justify-center relative group ${isActive(path) ? 'bg-cyan-400' : 'hover:bg-gray-800'}`;
  };

  const menuItems = [
    { path: '/', icon: <Compass size={24} />, label: 'Explorer' },
    { path: '/validators', icon: <User size={24} />, label: 'Validators' },
    { path: '/blocks', icon: <Package size={24} />, label: 'Blocks' },
    { path: '/blacknodes', icon: <img src="/blacknodes.png" alt="BlackNodes" className="w-6 h-6" />, label: 'BlackNodes' },
    { path: '/tokens', icon: <Shield size={24} />, label: 'Tokens' },
    { path: '/network', icon: <Globe size={24} />, label: 'Network' },
  ];

  return (
    <div className="fixed left-2 top-4 h-[calc(100vh-2rem)] w-18 bg-gray-900 border-r border-gray-800 flex flex-col items-center py-4 rounded-2xl overflow-visible">
      <div className="flex-grow flex flex-col justify-between">
        {menuItems.map((item, index) => (
          <Link key={item.path} to={item.path} className={getButtonClass(item.path)}>
            {item.icon}
            <span className="absolute left-full ml-2 bg-gray-800 text-white px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity duration-200 whitespace-nowrap z-50">
              {item.label}
            </span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Sidebar;